// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__a5Jfc .styles_feature__AHJYV {
  margin-bottom: 0.9rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Widget/ContactInformationWidget/styles.module.scss"],"names":[],"mappings":"AAAA;EAEQ,qBAAqB,EAAA","sourcesContent":[".container {\n    .feature {\n        margin-bottom: 0.9rem;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__a5Jfc`,
	"feature": `styles_feature__AHJYV`
};
export default ___CSS_LOADER_EXPORT___;
